import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../../../../../../components/Button";
import { DeleteContactDocument } from "../../../../../../__generated__/graphql";
import { useMutation } from "@apollo/client";
import toast from "react-hot-toast";

export default function DeleteContactButton({
  contactId,
  onDelete,
}: {
  contactId: string;
  onDelete: () => void;
}) {
  const [deleteContact, { loading: isDeletingContact }] = useMutation(
    DeleteContactDocument,
    {
      variables: { contactId },
    }
  );

  const handleDelete = async () => {
    try {
      const response = confirm("Voulez-vous vraiment supprimer ce contact ?");
      if (!response) return;

      await deleteContact();
      onDelete();
      toast.success("Contact supprimé avec succès");
    } catch (error) {
      console.error("Suppression du contact impossible:", error);
      toast.error("Suppression du contact impossible");
    }
  };

  return (
    <Button
      variant="secondary"
      className="text-sm text-secondary border-0 hover:text-secondary/80 p-0"
      onClick={handleDelete}
      isLoading={isDeletingContact}
    >
      <TrashIcon className="w-4 h-4" />
    </Button>
  );
}
